<template>
  <div>
    <main-layout
      controlsBg="light"
      :hasControlsBar="false"
      :breadcrumb="getBreadcrumb">
      <div class="container">
        <grid-row  class="margin-top-xl" column-align="center">
          <grid-col col-size="4">
            <div id="header">
              <h1 class="header-title">
                <chevron
                  @click="$router.push({name: 'Workspace'})"/>
                {{ $t('health.recipe.tag.title') }}
              </h1>
              <div class="header-add-button">
                  <span
                    v-tooltip.left.top-start="$t('health.recipe.tag.new')"
                    @click="createTag"
                  >
                    <font-awesome-icon
                      class="header-add-button-icon"
                      :icon="icon.add"/>
                  </span>
              </div>
              <alert
                v-if="alertVisible"
                :message="alertMessage"
                :type="alertType">
              </alert>
            </div>
          </grid-col>
        </grid-row>
        <grid-row  class="margin-top-xl" column-align="center">
          <grid-col col-size="4">
            <table-component
              ref="tagTable"
              :data="fetchData"
              sort-by="name"
              sort-order="asc"
              :show-caption="false"
              class="datatable"
              filter-placeholder=""
              filterNoResults="">
              <table-column
                show="id"
                :hidden="true"
                :filterable="false"
                data-type="boolean">
              </table-column>
              <table-column
                show="name"
                :label="$t('health.recipe.tag.name')"
                header-class="text-left"
                cell-class="table-component__text-left">
              </table-column>

              <table-column
                label=""
                :sortable="false"
                :filterable="false"
                header-class="table-component__minimum__width__column"
                cell-class="text-center">
                <template slot-scope="row">
                  <font-awesome-icon
                    v-if="row.name !== 'International' && row.name !== 'Internacional'"
                    v-on:click="editTag(row)"
                    :icon="icon.edit"
                    class="table-iconset-icon"/>
                  <font-awesome-icon
                    v-else
                    :icon="icon.edit"
                    class="table-icon-disabled"/>
                </template>
              </table-column>
              <table-column
                label=""
                :sortable="false"
                :filterable="false"
                header-class="table-component__minimum__width__column"
                cell-class="text-center">
                <template slot-scope="row">
                  <font-awesome-icon
                    v-if="row.name !== 'International' && row.name !== 'Internacional'"
                    v-on:click="removeTag(row)"
                    :icon="icon.remove"
                    class="table-iconset-icon"/>
                  <font-awesome-icon
                    v-else
                    :icon="icon.remove"
                    class="table-icon-disabled"/>
                </template>
              </table-column>
            </table-component>
          </grid-col>
        </grid-row>
      </div>
      <ok-cancel-modal
        v-if="showConfirmationDeleteModal"
        v-on:ok="onDeleteConfirm"
        v-on:cancel="onDeleteCancel"
        :title="deleteModalMessage"
        :message="deleteModalMessage"
        :okButton="$t('commons.delete')"
        :cancelButton="$t('commons.cancel')">
        <div slot="body">
          <ul>
            <li>
              {{ tagToDelete.name }}
            </li>
          </ul>
        </div>
      </ok-cancel-modal>

    </main-layout>
  </div>
</template>

<script>
import MainLayout from '@/layouts/MainLayout';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';
import TableComponent from '@/components/shared/table/components/TableComponent';
import TableColumn from '@/components/shared/table/components/TableColumn';
import pagination from '@/components/shared/table/pagination';
import Chevron from '@/components/shared/Chevron';
import OkCancelModal from '@/components/shared/dialogs/OkCancelModal';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import {faPencilAlt, faTrashAlt} from '@fortawesome/pro-regular-svg-icons';
import api from 'BRAND/api/recipe';
import {faPlusCircle} from '@fortawesome/pro-solid-svg-icons';
import {mapGetters} from 'vuex';
import Alert from '@/components/shared/alert/Alert';

export default {
  name: 'RecipeTagList',
  components: {
    MainLayout,
    GridRow,
    GridCol,
    TableComponent,
    TableColumn,
    FontAwesomeIcon,
    Chevron,
    OkCancelModal,
    Alert
  },
  data () {
    return {
      tags: [],
      breadcrumb: [
        {link: '/workspace', name: this.$t('menu.workspace')},
        {link: '/recipe-tag', name: this.$t('health.recipe.tag.title'), disabled: true}
      ],
      icon: {
        add: faPlusCircle,
        remove: faTrashAlt,
        edit: faPencilAlt
      },
      /* Alert */
      alertVisible: false,
      alertMessage: '',
      alertType: '', // error, warning, success'
      showConfirmationDeleteModal: false,
      tagToDelete: undefined,
      deleteModalMessage: '',
      /* Table */
      tablePageSize: 10,
      tableState: {
        filter: '',
        page: 1,
        sort: {
          order: '',
          fieldName: ''
        }
      }
    };
  },
  created () {
    const alert = this.$route.params.alert;
    if (alert !== undefined) {
      showAlert(this, this.$t(alert), 'success');
    }
  },
  mounted () {
    this.requestRecipeTags();
  },
  computed: {
    ...mapGetters([
      'getLanguageCode'
    ]),
    getBreadcrumb () {
      return this.breadcrumb;
    },
    getTags () {
      return this.tags;
    }
  },
  methods: {
    fetchData ({page, filter, sort}) {
      const tablePage = pagination.createPage(
        this.getTags,
        this.tableState,
        ['name'],
        this.tablePageSize,
        {page, filter, sort});
      this.tableState = tablePage.state;
      return tablePage.result;
    },
    requestRecipeTags () {
      const languageCode = this.getLanguageCode;
      api.getTags(this, languageCode)
        .then((response) => {
          this.tags = response.items.map((tag) => {
            return {
              id: tag.id,
              name: tag.name
            };
          });
          this.$refs.tagTable.refresh();
        })
        .catch((error) => {
          this.alertVisible = true;
          this.alertMessage = error;
          this.alertType = 'error';
        });
    },
    onDeleteConfirm () {
      api.removeTag(this, this.tagToDelete.id)
        .then(() => {
          this.requestRecipeTags();
          this.showConfirmationDeleteModal = false;
        })
        .catch((error) => {
          this.alertVisible = true;
          this.alertMessage = error;
          this.alertType = 'error';
        });
    },
    onDeleteCancel () {
      this.showConfirmationDeleteModal = false;
      this.tagToDelete = undefined;
      this.deleteModalMessage = '';
    },
    createTag () {
      this.$router.push({name: 'AddRecipeTag', params: {mode: 'create'}});
    },
    editTag (row) {
      this.$router.push({name: 'EditRecipeTag', params: {id: row.id, mode: 'edit'}});
    },
    removeTag (row) {
      this.tagToDelete = row;
      this.deleteModalMessage = this.$t('health.recipe.tag.delete');
      this.showConfirmationDeleteModal = true;
    }
  }
};

const showAlert = (context, message, type) => {
  context.alertVisible = true;
  context.alertMessage = message;
  context.alertType = type;
  context.showAlert = true;
  setTimeout(() => {
    context.alertVisible = false;
  }, 3000);
};

</script>

<style lang="scss">
@import "src/stylesheets/variables";

#header {
  display: inline-block;
  width: 100%;
  line-height: 1rem;
}
.header-title {
  float: left;
}
.header-add-button {
  float: right;
}
.header-add-button-icon {
  font-size: 3rem;
  color: $secondary;
}

.table-iconset-icon {
  cursor: pointer;
}

.table-icon-disabled {
  opacity: 0.4;
  margin: 0 0.5em;
  cursor: default;
}

</style>



// WEBPACK FOOTER //
// src/brand/health/layouts/recipe/RecipeTagList.vue